import React, { useEffect, useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { createFirstQuery, stepsCompleted, UpdateCompanyDetails } from "../../../../actions/globalAction";
import {
    getAllSupportedLanguages,
    googleTextTranslate,
    searchQueryResults,
    setBoolean,
    setKeywordTypeValue,
    setShowSample,
    toggleSampleButton,
    setFetchNewData,
    createRule,
} from "../../../../actions/queryBuilderActions";
import UseGAEventsTracker from "../../../hooks/UseGAEventsTracker";
import ConfigureKeywords from "../../../MainContent/queryBuilder/components/easyMode/ConfigureKeywords";
import {
    addExcludedField,
    addGenericField,
    addKeywordsField,
    handleQueryBuilder,
    langOptionsCalculations,
    validateBooleans,
} from "../../../MainContent/queryBuilder/components/easyMode/EasyMode";
import VideoModal from "../../../UIComponents/VideoModal/VideoModal";
import CurrentStepIndicator from "../CurrentStepIndicator";
import "./EasyQueryBuilder.scss";
import MobileVersionQueryBuilder from "./MobileVersionQueryBuilder";
import { ReactComponent as Play } from "../../../../assets/svg/play-button.svg";

const EasyQueryBuilder = ({ isMobile, history }) => {
    const dispatch = useDispatch();
    const keywordDivEnd = useRef(null);
    const phrasesDivEnd = useRef(null);
    const excludeDivEnd = useRef(null);
    const [submitting, setSubmitting] = useState(false);
    const [setupModeSampleButton, setSetupModeSampleButton] = useState(true);
    const [isDirtyAndNotValidated, setIsDirtyAndNotValidated] = useState(false);
    const [openPopup, setOpenPopup] = useState(true);

    const scrollKeywordTypesToBottom = (refType, position) => {
        refType.current?.scrollIntoView({ behavior: "smooth", block: position, inline: "nearest" });
    };
    const GAEventTracker = UseGAEventsTracker("New user SignUp");
    const company_identifier = useSelector((state) => state.globalReducer.company.company_identifier);
    const keywords = useSelector((state) => state.queryBuilderReducer.keywords);
    const genericKeyword = useSelector((state) => state.queryBuilderReducer.genericKeyword);
    const excludedKeyword = useSelector((state) => state.queryBuilderReducer.excludedKeyword);

    useEffect(() => {
        // varySteps(4);
        dispatch(getAllSupportedLanguages());
        dispatch(setFetchNewData(false));
        isMobile && addKeywordsField(keywords, dispatchKeywordType);
        GAEventTracker("SignUp step 4", `company-${company_identifier}`);

        const keywordList = [...keywords];
        keywordList[0]["keyword"] = "Apple";
        dispatch(setKeywordTypeValue([...keywordList], "keywords"));

        // const genericList = [...genericKeyword];
        // genericList[0]["keyword"] = "iPhone";
        // dispatch(setKeywordTypeValue([...genericList], "genericKeyword"));

        // if (!isMobile) {
        //     const excludedList = [...excludedKeyword];
        //     excludedList[0]["keyword"] = "fruit";
        //     dispatch(setKeywordTypeValue([...excludedList], "excludedKeyword"));
        // }

        resultantQuery();
        setIsDirtyAndNotValidated(false);
        // dispatch(createFirstQuery(true));
    }, []);

    const showSampleData = useSelector((state) => state.queryBuilderReducer.showSampleData);
    const showSampleButtonState = useSelector((state) => state.queryBuilderReducer.showSampleButtonState);
    const fetchNewData = useSelector((state) => state.queryBuilderReducer.fetchNewData);
    const expandKeywordBlock = useSelector((state) => state.queryBuilderReducer.expandKeywordBlock);
    const finalQuery = useSelector((state) => state.queryBuilderReducer.finalQuery);
    const selectedCountryOptions = useSelector((state) => state.queryBuilderReducer.selectedCountryOptions);
    const queryResults = useSelector((state) => state.queryBuilderReducer.queryResults);
    const queryResultsLoading = useSelector((state) => state.queryBuilderReducer.queryResultsLoading);
    const isQueryCreated = useSelector((state) => state.globalReducer.createFirstQuery);
    const user_id = useSelector((state) => state.globalReducer.company.user_id);

    const dispatchKeywordType = (val, type) => dispatch(setKeywordTypeValue(val, type));

    const handleKeyWordChange = (e, i) => {
        let querylength;
        if (!fetchNewData) {
            querylength = 1024;
        } else {
            let countryFilter = "";

            selectedCountryOptions?.forEach((country) => {
                if (country.gnip_filters?.length > countryFilter.length) countryFilter = country.gnip_filters;
            });

            if (countryFilter.length > 0) querylength = 2048 - (countryFilter.length + 4);
            else querylength = 2048;

            if (querylength > 1024) querylength = 1024;
            if (querylength < 0) querylength = 0;
        }
        if (finalQuery.length <= querylength) {
            const keywordList = [...keywords];
            keywordList[i]["keyword"] = e.target.value;
            if (keywordList[i]["translatedText"] !== "") {
                keywordList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            }
            dispatch(setKeywordTypeValue([...keywordList], "keywords"));
            resultantQuery();
            setIsDirtyAndNotValidated(true);
        } else {
            toast.error("Query length is exceeding specified character limit");
        }
        // this.props.setCheckIsDirty(true); need to check this
    };
    const handleGenericChange = (ev, i) => {
        let querylength;
        if (!fetchNewData) {
            querylength = 1024;
        } else {
            let countryFilter = "";

            selectedCountryOptions?.forEach((country) => {
                if (country.gnip_filters?.length > countryFilter.length) countryFilter = country.gnip_filters;
            });

            if (countryFilter.length > 0) querylength = 2048 - (countryFilter.length + 4);
            else querylength = 2048;

            if (querylength > 1024) querylength = 1024;
            if (querylength < 0) querylength = 0;
        }
        if (finalQuery.length < querylength) {
            const genericList = [...genericKeyword];
            genericList[i]["keyword"] = ev.target.value;
            if (genericList[i]["translatedText"] !== "") {
                genericList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            }
            dispatch(setKeywordTypeValue([...genericList], "genericKeyword"));
            resultantQuery();
            setIsDirtyAndNotValidated(true);
        } else {
            toast.error("Query length is exceeding specified character limit");
        }
        // this.props.setCheckIsDirty(true); need to check this
    };
    const handleExcludedKeyWord = (ev, i) => {
        let querylength;
        if (!fetchNewData) {
            querylength = 1024;
        } else {
            let countryFilter = "";

            selectedCountryOptions?.forEach((country) => {
                if (country.gnip_filters?.length > countryFilter.length) countryFilter = country.gnip_filters;
            });

            if (countryFilter.length > 0) querylength = 2048 - (countryFilter.length + 4);
            else querylength = 2048;

            if (querylength > 1024) querylength = 1024;
            if (querylength < 0) querylength = 0;
        }
        if (finalQuery.length < querylength) {
            const excludedList = [...excludedKeyword];
            excludedList[i]["keyword"] = ev.target.value;
            if (excludedList[i]["translatedText"] !== "") {
                excludedList[i]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
            }
            dispatch(setKeywordTypeValue([...excludedList], "excludedKeyword"));
            resultantQuery();
            setIsDirtyAndNotValidated(true);
        } else {
            toast.error("Query length is exceeding specified character limit");
        }
    };
    function getSelectedKeywordValue(keywordType) {
        switch (keywordType) {
            case "keywords":
                return keywords;

            case "genericKeyword":
                return genericKeyword;

            case "excludedKeyword":
                return excludedKeyword;

            default:
                break;
        }
    }
    const clearKeyword = (ind, keywordType) => {
        // const keywordList = [...this.props[keywordType]];
        // const keywordList = [...[keywordType]];

        let [keywordList] = [...[getSelectedKeywordValue(keywordType)]];

        if (keywordList[ind]["keyword"].length === 0 && keywordList.length > 1) {
            // console.log("hereee", keywordList);
            // console.log("hereee 2222", keywordList[ind].id);
            let objId = keywordList[ind].id;
            keywordList = keywordList.filter((obj) => obj.id !== objId);
        } else {
            keywordList[ind]["keyword"] = "";
            keywordList[ind]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
        }
        dispatch(setKeywordTypeValue([...keywordList], keywordType));
        resultantQuery();
        setIsDirtyAndNotValidated(true);
    };

    const enableTranslateBlock = (ind, keyWordType) => {
        // console.log("check for error...2", keyWordType, [keyWordType]);
        // const keywordList = [...this.props[keyWordType]];

        const [keywordList] = [...[getSelectedKeywordValue(keyWordType)]];

        let newList = [];
        if (keywordList[ind]["keyword"].length > 0) {
            if (keywordList[ind]["enable"] && keywordList[ind]["translateOptionsList"].length > 1) {
                newList = keywordList[ind]["translateOptionsList"].filter((ele, ind) => {
                    if ((ele.selectedLanguage !== null || ele.selectedLanguage?.length !== 0) && ele.translatedText !== "") {
                        return ele;
                    }
                });
                keywordList[ind]["translateOptionsList"] = newList;

                if (newList.length === 0) {
                    keywordList[ind]["translateOptionsList"] = [{ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }];
                }
            }
            keywordList[ind]["enable"] = !keywordList[ind]["enable"];
            dispatch(setKeywordTypeValue([...keywordList], keyWordType));
        }
    };

    const removeTranslate = (ind, keyWordType, point) => {
        // const keywordList = [...this.props[keyWordType]];
        const [keywordList] = [...[getSelectedKeywordValue(keyWordType)]];

        if (keywordList[ind]["translateOptionsList"][point]["translatedText"] !== "") {
            keywordList[ind]["translateOptionsList"][point]["translatedText"] = "";
            keywordList[ind]["translateOptionsList"][point]["selectedLanguage"] = [];
            keywordList[ind]["translateOptionsList"][point]["addedText"] = "";
            dispatch(setKeywordTypeValue([...keywordList], keyWordType));
            resultantQuery();
        } else {
            return false;
        }
    };

    const addTranslatedText = (ind, keyWordType, point) => {
        // let keywordList = [...this.props[keyWordType]];
        const [keywordList] = [...[getSelectedKeywordValue(keyWordType)]];

        if (
            keywordList[ind]["translateOptionsList"][point]["selectedLanguage"] === null ||
            keywordList[ind]["translateOptionsList"][point]["selectedLanguage"].length === 0
        ) {
            toast.error("Please select a language to translate your text");
            return;
        }
        keywordList[ind]["translateOptionsList"][point]["addedText"] = keywordList[ind]["translateOptionsList"][point]["translatedText"];
        dispatch(setKeywordTypeValue([...keywordList], keyWordType));
        resultantQuery();
    };

    const increaseTranslate = (ind, keyWordType, elem) => {
        // const keywordList = [...this.props[keyWordType]];
        const [keywordList] = [...[getSelectedKeywordValue(keyWordType)]];

        let lastItem = keywordList[ind].translateOptionsList[keywordList[ind].translateOptionsList.length - 1];
        if (lastItem.selectedLanguage === null || lastItem.selectedLanguage.length === 0) {
            return;
        }
        keywordList[ind].translateOptionsList.push({ selectedLanguage: [], translatedText: "", enable: false, addedText: "" }),
            dispatch(setKeywordTypeValue([...keywordList], keyWordType));

        if (keyWordType === "keywords") setTimeout(() => scrollKeywordTypesToBottom(keywordDivEnd, "end"), 0);
        if (keyWordType === "genericKeyword") setTimeout(() => scrollKeywordTypesToBottom(phrasesDivEnd, "center"), 0);
        if (keyWordType === "excludedKeyword") setTimeout(() => scrollKeywordTypesToBottom(excludeDivEnd, "center"), 0);
    };

    const handleLanguageChange = (selectedLanguge, ind, keyWordType, point) => {
        // const keywordList = [...this.props[keyWordType]];
        const [keywordList] = [...[getSelectedKeywordValue(keyWordType)]];

        keywordList[ind]["translateOptionsList"][point]["selectedLanguage"] = selectedLanguge;
        dispatch(setKeywordTypeValue([...keywordList], keyWordType));
        //translate code
        const textToTranslate = keywordList[ind]["keyword"];
        const languageSelected = selectedLanguge;
        if (textToTranslate === "") {
            toast.error("Please add a text for translation");
            return;
        }
        if (languageSelected == null || languageSelected.length === 0) {
            toast.error("Please select a language for translation");
            return;
        }
        let params = {};
        const content = [];
        content.push(textToTranslate);
        params["content"] = content;
        params["langCode"] = languageSelected.value;
        dispatch(googleTextTranslate(params))
            .then((res) => {
                keywordList[ind]["translateOptionsList"][point]["translatedText"] = res.value.data[0][0];
                dispatch(setKeywordTypeValue([...keywordList], keyWordType));
            })
            .catch((err) => {});
        // this.props.setCheckIsDirty(true); need to check this
    };

    const handleKeyPress = (e, keyWordType) => {
        if (e.charCode === 13 && e.target.value !== "") {
            if (keyWordType === "keywords") {
                // if (keywords.length < 20)
                addKeywordsField(keywords, dispatchKeywordType);
            } else if (keyWordType === "genericKeyword") {
                if (genericKeyword.length < 20) addGenericField(genericKeyword, dispatchKeywordType);
            } else if (keyWordType === "excludedKeyword") {
                if (excludedKeyword.length < 20) addExcludedField(excludedKeyword, dispatchKeywordType);
            }
        }
    };
    const characterLeftForBoolean = () => {
        let total;
        if (!fetchNewData) {
            // total = 5000;
            total = 1024;
        } else {
            let countryFilter = "";

            selectedCountryOptions?.forEach((country) => {
                if (country.gnip_filters?.length > countryFilter.length) countryFilter = country.gnip_filters;
            });

            if (countryFilter.length > 0) total = 1024 - (countryFilter.length + 4);
            else total = 1024;

            if (total > 1024) total = 1024;
        }

        let charactersLeft = total - finalQuery.length;
        return charactersLeft;
    };

    const newShowSampleData = () => {
        const query = finalQuery;
        const params = {};
        params["countries"] = "";
        params["query"] = query.replaceAll("\n", "");
        dispatch(searchQueryResults(params));
        setSetupModeSampleButton(true);

        if (!showSampleData) {
            dispatch(setShowSample(true));
        }
        // dispatch(toggleSampleButton());
    };

    const handleValidateButton = () => {
        const query = finalQuery;
        if (query === "") {
            toast.error("Please add your boolean query");
            return;
        }

        if (!validateBooleans(query)) {
            return false;
        }

        toast.success("No error with the Query");
        setIsDirtyAndNotValidated(false);
        !isQueryCreated && dispatch(createFirstQuery(true));
        setSetupModeSampleButton(false);
    };

    const showSamplePosts = () => {
        const query = finalQuery;
        if (query === "") {
            toast.error("Please add your boolean query");
            return;
        }
        if (!validateBooleans(query)) {
            return false;
        }
        // let selectedCountries = selectedCountryOptions;
        // if (selectedCountries.length === 0) {
        //     toast.error("Please select a Location");
        //     return;
        // }
        // if (!Array.isArray(selectedCountries)) {
        //     selectedCountries = [selectedCountries];
        // }
        // let countries = selectedCountries.map((ele) => {
        //     if (ele.label === "Worldwide") {
        //         return "";
        //     } else return ele.value;
        // });
        const params = {};
        params["countries"] = "";
        params["query"] = query.replaceAll("\n", "");
        //.replaceAll('"', "")

        if (!isQueryCreated) {
            dispatch(createFirstQuery(true));
            dispatch(stepsCompleted("createQuery"));
        }

        dispatch(searchQueryResults(params));
        if (!showSampleData) {
            dispatch(setShowSample(true));
        }
        dispatch(toggleSampleButton());
    };

    function resultantQuery() {
        // let checkKeywords = keywords;
        // let genericKeyword = genericKeyword;
        // let excludedKeyword = this.props.excludedKeyword;
        let keywordQuery = handleQueryBuilder(keywords);
        let genericQuery = handleQueryBuilder(genericKeyword);
        let excludedQuery = handleQueryBuilder(excludedKeyword);
        let combinedQuery = "";
        combinedQuery = combinedQuery.concat(keywordQuery);
        if (keywordQuery.length > 0) combinedQuery = " (" + combinedQuery + ") ";
        if (genericQuery.length > 0) {
            combinedQuery = combinedQuery.concat("\n");
            combinedQuery = combinedQuery.concat(" AND " + " (" + genericQuery + ") ");
        }
        if (excludedQuery.length > 0) {
            combinedQuery = combinedQuery.concat("\n");
            combinedQuery = combinedQuery.concat(" NOT " + " (" + excludedQuery + ") ");
        }

        // this.props.setBoolean(combinedQuery);
        setSetupModeSampleButton(true);
        dispatch(setBoolean(combinedQuery));
        if (showSampleButtonState && showSampleData) {
            // this.props.toggleSampleButton();
            dispatch(toggleSampleButton());
        }
    }
    const toggleShowSampleData = () => {
        dispatch(setShowSample(!showSampleData));
    };
    const handleNewQuerySubmit = async () => {
        // if (isQueryCreated) {
        if (finalQuery.length > 0) {
            let profile__setup = {
                is_profile_setup: 1,
            };
            let param = {};
            param["accounts"] = 1;
            param["boolean_query"] = finalQuery.replaceAll("\n", "");
            param["company_identifier"] = company_identifier;
            // param["countries"] = slectedLocationString;
            param["countries"] = "";
            param["data_fetch_enabled"] = 0;
            param["graph_color"] = "#4a90e2";
            param["name"] = "Topic 1";
            param["status"] = "Active";
            param["subtopic"] = "Query 1";
            param["subtopic_graph_color"] = "#d0021b";
            param["twitter_stream_query"] = "";
            param["user_id"] = String(user_id);
            // param["accountList"] = uniqueUpdatedAccounts;
            // this.props.createRule(param);
            try {
                setSubmitting(true);
                const res1 = await dispatch(createRule(param));
                const res = await dispatch(UpdateCompanyDetails(profile__setup));
                if (res) history.push("/completed");
                else toast.error("error");
            } catch (error) {
                toast.error("something went wrong. Please try again later");
            }
            setSubmitting(false);
        } else {
            // toast.error("Please create atleast 1 query to continue");
            toast.error("Please add your query to continue");
        }
    };
    const videoData = {
        url: `https://www.youtube.com/embed/L6clZpTgTJY`,
        title: "Create your own query",
        platformName: "Create Query",
    };

    return (
        <>
            <div className={`easy__query__builder__container ${isMobile && "mobile__query__container"} `}>
                <div className={`easy__query__heading ${isMobile && "mobile__version__heading"}`}>Create Query</div>

                <div className="help__container">
                    <p className="help__text">Help me to create a query (</p>
                    <span className="pointer__container" onClick={() => setOpenPopup(true)}>
                        <span className="light__text"> Watch help video </span>
                        <Play className="watch__icon" />
                    </span>
                    <span className="help__text">)</span>
                </div>

                {isMobile ? (
                    <>
                        <MobileVersionQueryBuilder
                            genericKeyword={genericKeyword}
                            handleKeyWordChange={handleKeyWordChange}
                            handleGenericChange={handleGenericChange}
                            keywords={keywords}
                            rawData={queryResults?.hits}
                            queryResults={queryResults}
                            queryResultsLoading={queryResultsLoading}
                            clearKeyword={clearKeyword}
                            // showSampleButtonState={showSampleButtonState}
                            showSampleButtonState={setupModeSampleButton}
                            // showSamplePosts={showSamplePosts}
                            showSamplePosts={newShowSampleData}
                            handleValidateButton={handleValidateButton}
                            setSetupModeSampleButton={setSetupModeSampleButton}
                            finalQuery={finalQuery}
                        />
                    </>
                ) : (
                    <div className="empty__div">
                        <Scrollbars autoHide>
                            <ConfigureKeywords
                                // expandKeywordBlock={expandKeywordBlock}
                                hideTabs
                                isSetupMode={true}
                                expandKeywordBlock={true}
                                selectedCountryOptions={selectedCountryOptions}
                                handleCountryChange={false} //need to change this
                                disableLocationTab={true}
                                keywords={keywords}
                                addKeywordsField={addKeywordsField}
                                handleKeyWordChange={handleKeyWordChange}
                                handleKeyPress={handleKeyPress}
                                clearKeyword={clearKeyword}
                                enableTranslateBlock={enableTranslateBlock}
                                langOptionsCalculations={langOptionsCalculations}
                                handleLanguageChange={handleLanguageChange}
                                increaseTranslate={increaseTranslate}
                                addTranslatedText={addTranslatedText}
                                removeTranslate={removeTranslate}
                                keywordDivEnd={keywordDivEnd}
                                genericKeyword={genericKeyword}
                                addGenericField={addGenericField}
                                handleGenericChange={handleGenericChange}
                                excludedKeyword={excludedKeyword}
                                toggleShowSampleData={toggleShowSampleData}
                                phrasesDivEnd={phrasesDivEnd}
                                excludeDivEnd={excludeDivEnd}
                                // showSampleButtonState={showSampleButtonState}
                                showSampleButtonState={setupModeSampleButton}
                                // showSamplePosts={showSamplePosts}
                                showSamplePosts={newShowSampleData}
                                rawData={queryResults?.hits}
                                queryResultsLoading={queryResultsLoading}
                                queryResults={queryResults}
                                finalQuery={finalQuery}
                                characterLeftForBoolean={characterLeftForBoolean}
                                isSampleDataBlockOpened={showSampleData}
                                fetchNewData={fetchNewData}
                                addExcludedField={addExcludedField}
                                handleExcludedKeyWord={handleExcludedKeyWord}
                            />
                        </Scrollbars>
                    </div>
                )}
                {openPopup ? <VideoModal open={openPopup} hideModal={() => setOpenPopup(false)} videoData={videoData} crossOrigin="" /> : null}

                {/* {!isMobile && (
                    <div className="validate__button__container">
                        <button
                            className="validate__button"
                            // disabled={showSampleButtonState}
                            onClick={() => {
                                handleValidateButton();
                            }}>
                            Validate Query
                        </button>
                    </div>
                )} */}

                {!isMobile ? (
                    <p className="web__text">
                        Include words that CONTAINS any of the above keywords (This acts as a primary search. eg: citibank, citi bank, citi)
                    </p>
                ) : null}

                <p className="note__text">
                    Note: Please note that during your free 7-day trial, you will be able to use the full functionality of the platform. However, you will only
                    get limited data for your queries. Upgrade at any time to view more data for your queries.
                </p>
            </div>
            <div className="porfile__setup__footer">
                <button className={`button back__button  ${isMobile && "mobile__version__button"} `} onClick={() => history.goBack()}>
                    Previous
                </button>
                {isMobile ? <div>Step 4 of 4</div> : <CurrentStepIndicator StepCount={4} />}
                <Popup
                    content="Please add your query to continue"
                    inverted
                    size="mini"
                    position="top center"
                    style={{ zIndex: "99999" }}
                    // disabled={isQueryCreated}
                    disabled={finalQuery.length > 0}
                    trigger={
                        <button
                            className={`button 
                         ${finalQuery.length < 1 && "disabled__mode"}
                             ${isMobile && "mobile__version__button"}`}
                            onClick={handleNewQuerySubmit}
                            disabled={submitting}>
                            {/* <span>{submitting && <Loader active size="large" />} Next</span> */}
                            <span className="relative__loader">{submitting ? <Loader active /> : "Next"}</span>
                        </button>
                    }
                />
            </div>
        </>
    );
};

export default EasyQueryBuilder;
